import { BaseComponent } from '../../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Modal } from '../../../../../components/Modal';
import { IsOpen, Plus } from '../../../../../components/Icon';
import { HBox, VBox } from '../../../../../components/Box';
import { Card } from '../../../../../components/Card';
import { Button } from '../../../../../components/Buttons';
import { Times, Camera } from '../../../../../components/Icon';
import { Checkbox } from '../../../../../components/Checkbox';
import { VehiclePropertyLoadable } from '../../../components/VehiclePropertyLoadable';

import { addDocument, deleteDocument } from '../../../../Documents/actions';
import {
  addVehicleOption,
  deleteVehicleProperty,
  downloadZipFiles,
  removeVehicleOption,
  setVehicleProperty,
} from '../../../actions';
import { selectWorks, selectWork, selectPermissions } from '../../../../Api/selectors';
import { selectAllOptions } from '../../../selectors';
import {
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  VEHICLE_OPTIONS,
  VEHICLE_OPTIONS2,
  VEHICLE_OPTIONS_HOOIKAMMER,
  VEHICLE_OPTIONS_IDW,
  WS2_1_GENERAL_PHOTOS,
  WS2_1_IMPRESSION_PHOTOS,
} from '../../../constants';
import { REQUEST_INVOICE_FILTER } from '../../../../Invoices/constants';
import { COLOR_PRIMARY_1, COLOR_BG_LIGHT } from '../../../../../vars';
import { resizeAndRotate } from '../../../../../utils/image';
import { getPropByName } from '../../../../../utils/props';
import _ from 'lodash';
import { REQUEST_DELETE_DOCUMENT } from '../../../../Users/constants';
import { Loader } from '../../../../../components/Loader';
import { WS2_1_Interior } from '../../../../KanbanBoards/cells/WS/WS2_1_Interior';
import { selectActions } from '../../../../Actions/selectors';
import env from '../../../../../env';
import { AppClientId } from '../../../../Shared/constants';
import { PhotoLayers } from './PhotoLayers';
import { ButtonBar } from '../../../../../components/ButtonBar';
import cn from 'classnames';
import ImageCarouselComponent from '../../../../../containers/App/Components/Carousel/Carousel';
import CheckboxComponent from '../../../../../containers/App/Components/Checkbox/Checkbox';
import styles from './EditVehicleOptions.module.css';
import ModalComponent from '../../../../../containers/App/Components/Modal/Modal';
import LoadingDetailsPageCard from '../../../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import ButtonComponent from '../../../../../containers/App/Components/Button/Button';
import ImageServiceCarouselComponent from '../../../../../containers/App/Components/CarouselImageService/CarouselImageService';
import {
  DEP_FINANCE,
  COMPANY_CRUD,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  VEHICLE_LOGS,
  DEP_TRANSPORT,
} from '../../../../../components/Permission/constants';
import { hasPermissions } from '../../../../../utils/helpers/permissions';
import { validateImageSrc } from '../../../helpers';
import { isMobileDevice } from '../../../../../utils/checkDevice';

const Container = styled.div`
  .modal-inner {
  }
  .option {
    &.inactive {
      opacity: 0.5;
    }
  }

  .title {
    margin: 8px 0;
    text-transform: uppercase;
    font-size: 12px;
  }

  width: 100%;
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }
  .icon-edit-square {
    color: #d9d9d9;
  }

  .option-container {
    font-weight: 600;
    color: gray;
  }

  .import-img-photoblock {
    width: 90%;
    height: 95%;
    flex-shrink: 0;
    background-size: cover;
    background-position: center center;
    .add {
      width: 100px;
      height: 100px;
    }
  }

  .grid {
    display: grid;
    grid-gap: 10px;
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }

  .cell {
    margin: 5px;
    height: 150px;
    background-color: #f0f0f0;
    font-weight: 600;
    text-align: center;
    padding-top: 10px;
  }

  @media (max-width: 375px) {
    .grid {
      grid-template-columns: 1fr;
    }
  }

  @media (min-width: 376px) and (max-width: 500px) {
    .grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 501px) and (max-width: 1023px) {
    .grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media (min-width: 1024px) {
    .grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .info-card {
    width: 100%!important;
  }

  .import-photo-wrapper {
    justify-content: space-between;
    height: 100%;
  }

  .extra-photo-wrapper {
    justify-content: center;
  }

  .image-available {
    width: 32px;
    height: 32px;
    background-color: ${COLOR_PRIMARY_1};
    color: white;
    border-radius: 15px;
    text-align: center;
    margin-right: 3px;
    margin-left: -40px;
    padding-top: 3px;

    .icon {
      margin: 0;
      padding: 0 0;
    }
  }


  .triple {
    display: flex;
    gap: 12px;
    margin: 12px 0;

    transition: opacity 0.2s;
    .check {
      /* transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px; */
      transition: opacity 0.2s;
      width: 24px;
      height: 24px;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      display: flex;
      align-items: stretch;
      justify-content: center;
      background-color: #0183D5;
      color: #fff;
      border-radius: 0.375rem;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        /* border: 1px solid #3bb78e;
        color: #3bb78e; */
        background-color: var(--color-new-secondary);
      }
    }
    &.triple-2 {
      .check {
        /* border: 1px solid red;
        text-align: center;
        color: red; */
        background-color: #fa5c7c;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
  }

  .img {
    width: 100%;
    min-height: 480px;
    background-size: contain;
  }
`;

const ShowButton = styled.span`
  font-weight: bold;
  font-size: 12px;
  color: #0183d5;
  opacity: ${props => (props.disabled ? '0.7' : '1')};
  text-decoration: underline;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  margin-left: 12px;
`;

const Subtitle = styled.h3`
  width: 100%;
  background: #eff1f7;
  font-weight: bold;
  padding: 4px;
  font-size: 14px;
`;

const STATE = {
  searchString: '',
  editMode: true,
  showAll: false,
  mileage: '',
  carouselImages: [],
  showModalLayerToevoegen: false,
  currentImageUrl: '',
  currentImageId: '',
  showModalAchetergroundToevoegen: false,
  showCarousel: false,
  isOpen: false,
};

/* eslint-disable react/prefer-stateless-function */
class EditVehicleOptionsComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (hasPermissions(this.props.permissions, DEP_COMMERCE)) {
      this.setState({ isOpen: true });
    }
    if (env.clientId === AppClientId.INDEWAL) {
      this.getValid();
    }
    this.setState({ mileage: getPropByName(this.props.vehicle, 'mileage') });
  }

  getValid = callback => {
    validateImageSrc(this.vehicle?.id).then(res => {
      if (res) {
        return this.setState({
          storageImage: true,
        });
      }
    });
    return null;
  };

  get vehicle() {
    return this.props.vehicle;
  }

  get tripleCheckProps() {
    let props = ['has_instruction_book', 'has_maintenance_book'];

    return props;
  }

  get spinImages() {
    if (!this.state.storageImage || env.clientId !== AppClientId.INDEWAL) {
      return [];
    }
    const currentDomain = `${window.location.protocol}//${window.location.host}`;
    return Array.from({ length: 9 }, (_, i) => `${currentDomain}/storage/documents/spin/${this.vehicle?.id}/1-${i + 1}.jpg`);
  }

  renderTripleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + name);

    return (
      <HBox left vCenter key={name} className="justify-content-between">
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 2 : 0)}
        >
          <VehiclePropertyLoadable name={name}>
            <div className="check">{state == 0 ? '-' : state == 1 ? '+' : 'x'}</div>
          </VehiclePropertyLoadable>
          <div className={cn('label', styles.labelCamera)}>{this.lbl(`vehicle.property.${name}`)}</div>
        </div>

        {photo ? (
          <div
            className={cn('pointer image-available', styles.buttonCamera)}
            onClick={() => {
              let container = document.getElementsByClassName('modal-inner')[0];
              let renderOptionPhotoDims = container.getBoundingClientRect();
              this.setState({
                renderOptionPhoto: photo.id,
                renderOptionPhotoDims,
              });
            }}
          >
            <Camera />
          </div>
        ) : (
          <div onClick={this.setStateFn({ optionPhoto: name })} className={cn('pointer', styles.buttonCamera)}>
            <VehiclePropertyLoadable name={name}>
              <Camera
                onClick={() =>
                  this.capture(
                    name,
                    this.callback(() => this.props.setProperty(name, 1)),
                  )
                }
              />
            </VehiclePropertyLoadable>
          </div>
        )}
      </HBox>
    );
  }

  propertyValue(name) {
    return this.props.vehicle?.[name];
  }

  capture(name, callback, docType) {
    //remove existing image upload
    const type = docType ? docType : 'photo_interior_';
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';
    // input.setAttribute('capture', 'camera');

    if (isMobileDevice()) {
      input.setAttribute('capture', 'environment');
    }

    document.body.appendChild(input);

    input.click();

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          this.props.imageUpload(
            {
              name,
              type: type + name,
              originalFilename: 'originalFilename',
              file,
            },
            'upload_' + name,
          );

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  onCommentChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  toggleOption(id, state) {
    this._lastOption = id;

    //todo: busy_ ... is depricated
    this.setState(
      { [`busy_${id}`]: true },
      this.props.toggleOption(id, state, result => {
        this.setState({ [`busy_${id}`]: false });
      }),
    );
  }

  handlePhotoDelete = documentId => {
    if (confirm()) {
      const group = this.props.vehicle?.documents?.find(d => d.id === documentId)?.type;
      if (this.props.vehicle?.documents?.filter(d => d?.type === group)?.length === 1) {
        const index = group?.slice(25);
        this.setState({ [`attention_comment_${index}`]: '' });
        this.props.deleteProperty(`attention_comment_${index}`);
        this.props.deleteProperty(`attention_repaired_${index}`);
        this.props.deleteProperty(`attention_displayed_${index}`);
      }
      this.props.deleteDocument(documentId, this.setStateFn({ renderOptionPhoto: null }));
    }
  };

  closeCarousel() {
    this.setState({ showCarousel: false, carouselImages: [] });
  }

  getActionIdByName(name) {
    return this.props?.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  renderActionModal() {
    if (!this.props.webLogin && env.clientId === AppClientId.INDEWAL) {
      return (
        <div className="mb-2">
          <WS2_1_Interior
            vehicleDetails
            cell={{ vehicle: this.props.vehicle }}
            action={{ label: 'label', id: this.getActionIdByName('WS2_1_Interior') }}
            payload={{ task_name: 'task_spray' }}
            column={{ label: 'WS2_1_Interior' }}
          />
          <Button className={styles.button} onClick={this.tofn(`/boards/1/generic-inspection/${this.props.vehicle.id}`)}>
            {this.lbl('vehicle.linktree.generic_inspecteren')}
          </Button>
        </div>
      );
    } else {
      return null;
    }
  }

  renderOptionPhoto() {
    if (!this.state.renderOptionPhoto) return null;
    let index = '';
    const filteredDocuments = this.props.vehicle.documents?.filter(doc => doc.type?.startsWith('photo_option_')) || [];
    const carouselImages = filteredDocuments.map(doc => ({
      id: doc.id,
      url: doc.url,
    }));

    if (this.state.currentImageId) {
      index = carouselImages?.findIndex(img => img?.id == this.state.currentImageId);
    }

    return (
      <ModalComponent
        size="lg"
        onClose={this.closeCarousel.bind(this)}
        mediumWide
        title={this.lbl('interior.inspection.photos')}
      >
        <ImageServiceCarouselComponent
          imgURLs={carouselImages}
          vehicleId={this.vehicle?.id}
          onDeleteImg={this.handlePhotoDelete}
          onImageChange={this.setCurrentImage}
          currentImageIndex={index}
          onImageClick={currentImage => {
            this.setState({ currentImageId: currentImage });
          }}
        />
      </ModalComponent>
    );
  }

  renderOption(value, index) {
    if (value.title)
      return (
        <VBox className={cn('title', styles.gridItemTitle)} key={index}>
          <strong>{this.lbl(`vehicle.options.${value.title}`)} </strong>
        </VBox>
      );

    let options = this.props.allOptions?.filter(o => o.name.toLowerCase() === value.toLowerCase());

    let optionId = options?.[0]?.id;

    let vehicleHasOption;

    for (let i = 0; i < options?.length || 0; i++) {
      for (let j = 0; j < this.props.vehicle.options?.length || 0; j++) {
        let o1 = options[i];
        let o2 = this.props.vehicle.options[j];
        if (o1.id == o2.id && o2.VehicleHasOption.isSelected) {
          vehicleHasOption = o2;
          optionId = vehicleHasOption.id;
        }
      }
    }

    if (!optionId) return null;

    if (vehicleHasOption) options = this.props.allOptions?.find(o => o.autotelexId == vehicleHasOption.autotelexId);

    vehicleHasOption = vehicleHasOption?.VehicleHasOption?.isSelected ? vehicleHasOption : null;

    let checked_name = `checked_${value}`;

    let checked = this.state[checked_name] || vehicleHasOption;
    let photo = this.props.vehicle.documents?.find(document => document.type == 'photo_option_' + value);

    let name = `vehicle-option-${optionId}`;
    let width = 100 / 3;
    return (
      <div key={index} className={cn(`option ${!options ? 'inactive' : ''} option-${optionId}`, styles.gridItem)}>
        <div className="option-container">
          <VehiclePropertyLoadable name={name}>
            <CheckboxComponent
              className={styles.checkbox}
              checked={checked}
              label={value}
              onChange={options && this.state.editMode ? () => this.toggleOption(optionId, !checked) : null}
            />
          </VehiclePropertyLoadable>
        </div>

        <VehiclePropertyLoadable name={`upload_${value}`}>
          {photo ? (
            <div
              className="pointer image-available"
              onClick={() => {
                let container = document.getElementsByClassName('option-inner')[0];
                let renderOptionPhotoDims = container.getBoundingClientRect();
                this.setState({
                  renderOptionPhoto: photo.id,
                  currentImageId: photo.id,
                  renderOptionPhotoDims,
                  showCarousel: true,
                });
              }}
            >
              <Camera />
            </div>
          ) : (
            <div onClick={this.setStateFn({ optionPhoto: optionId })} className="pointer">
              <Camera
                onClick={() =>
                  this.capture(
                    value,
                    this.callback(() => this.props.toggleOption(optionId, true)),
                    'photo_option_',
                  )
                }
              />
            </div>
          )}
        </VehiclePropertyLoadable>
      </div>
    );
  }

  renderPlaceholderImage(vehiclePurpose, type) {
    return env.clientId == AppClientId.HOOIKAMMER || env.clientId == AppClientId.HILTERMANN ? (
      <HBox center key={type} style={{ width: '100%', height: '100%' }}>
        <div
          className="import-img-photoblock"
          style={{
            opacity: '0.7',
            backgroundImage: `url('/public/images/ws2_1_interior_defaults/import/${type}.jpg')`,
          }}
        ></div>
      </HBox>
    ) : (
      <HBox center key={type} style={{ width: '100%', height: '100%' }}>
        <div
          className="import-img-photoblock"
          style={{
            opacity: '0.7',
            backgroundImage: `url('/public/images/ws2_1_interior_defaults/general/${type}.jpg')`,
          }}
        ></div>
      </HBox>
    );
  }

  addImportImage(index, type, isNewGroup = false) {
    env.clientId === AppClientId.HOOIKAMMER || env.clientId === AppClientId.HILTERMANN
      ? this.capture('import_' + index + ' ' + type)
      : this.capture('general_' + index + ' ' + type);
  }

  downloadImages(imagesURLs) {
    this.setState({ downloadImages: true }, () => {
      this.props.downloadZip(imagesURLs, result => {
        this.setState({ downloadImages: false });
        window.open('/storage/zip/' + this.props.vehicle?.id + '.zip');
      });
    });
  }

  getPhotoData = documents => {
    if (!documents) return [];

    return documents
      .filter(doc => doc.type && doc.type.startsWith('photo_interior_'))
      .map(doc => ({
        id: doc.id,
        type: doc.type,
        url: doc.url,
      }));
  };

  renderModalLayerToevoegen = (photoGroup, position, img) => {
    let index = '';
    let imgToLayers = img;
    // return;
    if (this.state.currentImageId) {
      index = photoGroup?.findIndex(img => img?.id == this.state.currentImageId);
    }
    if (this.state.storageImage) {
      index = img;
      imgToLayers = this.state.currentImageUrl;
    }
    return position === 'top' ? (
      <ModalComponent onClose={this.closeModalLayerToevoegen.bind(this)} title="Layer toevoegen" size="xl">
        {/* <div>
          <img src={img?.url} alt="Vehicle general image" style={{ objectFit: 'contain', width: '100%' }} />
        </div> */}
        <ImageServiceCarouselComponent
          vehicleId={this.vehicle?.id}
          imgURLs={photoGroup}
          imageUrlsSpin={this.spinImages}
          onDeleteImg={this.handlePhotoDelete}
          currentImageIndex={index}
          onImageChange={this.setCurrentImage}
        />
        <div>{env.photo_layers ? this.renderPhotoLayers(imgToLayers, position) : null}</div>
      </ModalComponent>
    ) : (
      <ModalComponent onClose={this.closeModalAchetergroundToevoegen.bind(this)} title="Foto bekijken" size="xl">
        <ImageServiceCarouselComponent
          vehicleId={this.vehicle?.id}
          imgURLs={photoGroup}
          imageUrlsSpin={this.spinImages}
          onDeleteImg={this.handlePhotoDelete}
          currentImageIndex={index}
          onImageChange={this.setCurrentImage}
        />
        {/* <div>
          <img src={img?.url} alt="Vehicle general image" style={{ objectFit: 'contain', width: '100%' }} />
        </div> */}
        <div>{env.photo_layers ? this.renderPhotoLayers(imgToLayers, position) : null}</div>
      </ModalComponent>
    );
  };

  openModalLayerToevoegen() {
    this.setState({ showModalLayerToevoegen: true });
  }

  openModalAchetergroundToevoegen() {
    this.setState({ showModalAchetergroundToevoegen: true });
  }

  closeModalLayerToevoegen() {
    this.setState({ showModalLayerToevoegen: false });
  }
  closeModalAchetergroundToevoegen() {
    this.setState({ showModalAchetergroundToevoegen: false });
  }

  setCurrentImage = img => {
    this.setState({ currentImageUrl: img });
  };

  renderPhotoCarousel = () => {
    if (!this.props.vehicle) return null;
    let defaults = WS2_1_GENERAL_PHOTOS;
    let phototype = 'photo_interior_general_0';
    if (env.clientId == AppClientId.HOOIKAMMER || env.clientId == AppClientId.HILTERMANN) {
      defaults = WS2_1_IMPRESSION_PHOTOS;
      phototype = 'photo_interior_import_0';
    }
    let rows = [];

    defaults?.map((type, i) => {
      let photos = this.props.vehicle?.documents?.filter(d => {
        return d?.type?.indexOf(`${phototype} ${type}`) === 0;
      });

      return rows.push({
        index: i,
        placeholder: type,
        photos,
      });
    });
    let extraPhotos = this.props.vehicle?.documents?.filter((d, index) => {
      return d.type?.includes(`${phototype} extra_`);
    });

    extraPhotos?.map((d, index) => {
      return rows.push({
        placeholder: `extra_${index + 1}`,
        photos: [d],
      });
    });
    let photoGroup = [];
    rows.map(row => {
      if (row?.photos?.length) {
        photoGroup.push(row?.photos[0]);
      }
    });

    const imgToLayers = this.state.storageImage ? this.state.currentImageId : this.state.currentImageUrl;
    return (
      <>
        <ImageServiceCarouselComponent
          imgURLs={photoGroup}
          imageUrlsSpin={this.spinImages}
          vehicleId={this.vehicle?.id}
          onDeleteImg={this.handlePhotoDelete}
          onImageChange={this.setCurrentImage}
          onImageClick={currentImage => {
            this.setState({ currentImageId: currentImage });
            this.openModalAchetergroundToevoegen();
          }}
        />
        {env.clientId !== AppClientId.HOOIKAMMER && env.clientId !== AppClientId.HILTERMANN && (
          <ShowButton
            disabled={!photoGroup?.length || this.state.downloadImages}
            onClick={() => (!photoGroup?.length || this.state.downloadImages ? () => {} : this.downloadImages(photoGroup))}
          >
            {this.state.downloadImages ? <Loader small /> : this.lbl('download')}
          </ShowButton>
        )}
        {/* {photoGroup.length > 0 ? ( */}
        <>
          <div className={styles.buttonModalContainer}>
            {/* <ButtonComponent style="ButtonSoftPrimary" onClick={() => this.openModalLayerToevoegen()}>
                Layer toevoegen
              </ButtonComponent> */}
            {env.clientId !== AppClientId.HOOIKAMMER && env.clientId !== AppClientId.HILTERMANN && (
              <ButtonComponent style="ButtonSoftPrimary" onClick={() => this.openModalAchetergroundToevoegen()}>
                Achtergrond toevoegen
              </ButtonComponent>
            )}
          </div>
          {this.state.showModalLayerToevoegen && this.renderModalLayerToevoegen(photoGroup, 'top', imgToLayers)}
          {this.state.showModalAchetergroundToevoegen && this.renderModalLayerToevoegen(photoGroup, 'bottom', imgToLayers)}
        </>
        {/* ) : null} */}
      </>
    );
  };
  renderPhotoLayers(document, position) {
    return <PhotoLayers document={document} position={position} />;
  }

  renderImportPhotos() {
    const v = this.props.vehicle;

    if (!v) return null;

    const vehiclePurpose = getPropByName(this.vehicle, 'vehicle_purpose');

    let defaults = WS2_1_GENERAL_PHOTOS;
    let phototype = 'photo_interior_general_0';
    if (env.clientId === AppClientId.HOOIKAMMER) {
      defaults = WS2_1_IMPRESSION_PHOTOS;
      phototype = 'photo_interior_import_0';
    }

    let URLs = [];
    let rows = [];

    defaults?.map((type, i) => {
      let photos = v?.documents?.filter(d => {
        return d?.type?.indexOf(`${phototype} ${type}`) === 0;
      });

      if (this.props.photoBlock && photos?.length) {
        URLs.push(photos[0]?.url);
      }

      return rows.push({
        index: i,
        placeholder: type,
        photos,
      });
    });

    let extraPhotos = v?.documents?.filter((d, index) => {
      return d.type?.includes(`${phototype} extra_`);
    });

    extraPhotos?.map((d, index) => {
      if (this.props.photoBlock) {
        URLs.push(d?.url);
      }
      return rows.push({
        placeholder: `extra_${index + 1}`,
        photos: [d],
      });
    });

    let photoGroup = [];
    rows.map(row => {
      if (row?.photos?.length) {
        photoGroup.push(row?.photos[0]);
      }
    });

    return (
      <>
        {this.props.photoBlock && (
          <Subtitle className={styles.subtitle} style={{ display: 'flex', justifyContent: 'space-between' }}>
            {this.lbl('interior.inspection.general_photo')}
            {env.clientId !== AppClientId.HOOIKAMMER && env.clientId !== AppClientId.HILTERMANN && (
              <ShowButton
                disabled={!URLs?.length || this.state.downloadImages}
                onClick={() => (!URLs?.length || this.state.downloadImages ? () => {} : this.downloadImages(URLs))}
              >
                {this.state.downloadImages ? <Loader small /> : this.lbl('download')}
              </ShowButton>
            )}
          </Subtitle>
        )}

        <div key="import_photos" className="grid">
          {rows.map(row => {
            if (this.props.photoBlock && row?.photos?.length) {
              return (
                <div key={row?.placeholder}>
                  <div className="cell">
                    <VBox center className="import-photo-wrapper">
                      {row?.photos?.map(doc => this.renderImportPhoto(doc, photoGroup))}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  </div>
                </div>
              );
            } else if (this.props.photoBlock && !row?.photos?.length) {
              return;
            }
            return (
              <div key={row?.placeholder}>
                <div className="cell">
                  {row?.photos?.length > 0 ? (
                    <VBox center className="import-photo-wrapper">
                      {row?.photos?.map(doc => this.renderImportPhoto(doc, rows))}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  ) : (
                    <VBox center className="import-photo-wrapper" onClick={() => this.addImportImage(0, row.placeholder)}>
                      {this.renderPlaceholderImage(vehiclePurpose, row?.placeholder)}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  )}
                </div>
              </div>
            );
          })}
          {!this.props.photoBlock && (
            <div className="cell">
              <HBox
                vCenter
                className="import-photo-wrapper extra-photo-wrapper"
                onClick={() => this.addImportImage(0, `extra_${extraPhotos?.length}`)}
              >
                <div style={{ fontSize: '26px' }}>
                  <Plus />
                </div>
              </HBox>
            </div>
          )}
        </div>
        {!this.props.photoBlock && <HBox style={{ width: '50%' }}></HBox>}
      </>
    );
    return null;
  }

  renderImportPhoto(document, photoGroup) {
    let photo = !this.props.photoBlock
      ? photoGroup.filter(doc => doc?.photos?.[0])?.map(img => img?.photos?.[0])
      : photoGroup;
    const getCurrent = currentId => {
      let current = photo.filter(image => image.id == currentId);

      return current;
    };
    return (
      <HBox center key={`import-${document.id}`} style={{ width: '100%', height: '100%' }}>
        <div
          className="import-img-photoblock"
          style={{
            width: '100%',
            height: '95%',
            backgroundImage: `url('${encodeURI(decodeURI(document.url)).replace(/%5C/g, '/')}')`,
          }}
        ></div>
      </HBox>
    );
  }

  render() {
    if (this.props.works) return <LoadingDetailsPageCard />;

    return (
      <Container
        photoBlock={this.props.photoBlock}
        className={cn('option-inner modal-inner', styles.container)}
        itemsLength={this.props.invoices?.length}
      >
        {this.state.showCarousel && this.renderOptionPhoto()}
        {!this.props.optionStep && (
          <>
            <HBox vCenter left>
              <h2>Exterieurfoto's vanuit inspectie</h2>
              <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>
            </HBox>
          </>
        )}

        {this.renderImportPhotos()}

        {this.state.isOpen && (
          <>
            {this.props.photoBlock &&
              env.clientId !== AppClientId.HOOIKAMMER &&
              env.clientId !== AppClientId.HILTERMANN &&
              this.renderActionModal()}

            {this.renderPhotoCarousel()}
          </>
        )}
        {!this.props.photoBlock && (
          <Card className="vehicle-info-card info-card data info-card-wide" style={{ width: '100%' }}>
            {env.clientId === AppClientId.AUTOWIENTJES && (
              <div className={styles.gridContainer}>
                <div className={styles.gridItem}>
                  {/* <p style={{ marginRight: '10px' }}></p> */}
                  <label className="form-label">{this.lbl('vehicle.property.num_keys')}</label>
                  <VehiclePropertyLoadable name="num_keys">
                    <div className={styles.containerButtonBar}>
                      <ButtonBar>
                        {_.times(5, num => {
                          num += 1;
                          return (
                            <Button
                              className={styles.buttonBarItem}
                              key={num}
                              small
                              disabled={this.props.work}
                              primary={num == this.propertyValue('num_keys')}
                              onClick={() => {
                                this.props.setProperty('num_keys', num);
                              }}
                            >
                              {num}
                            </Button>
                          );
                        })}
                      </ButtonBar>
                    </div>
                  </VehiclePropertyLoadable>
                </div>

                <div className={styles.gridItem}>{this.renderTripleCheck('has_instruction_book')}</div>
                <div className={styles.gridItem}>{this.renderTripleCheck('has_maintenance_book')}</div>
              </div>
            )}
            <HBox vCenter>
              <h2 className="card-title mb-1 text-muted" style={{ fontSize: '20px', marginTop: '10px' }}>
                {this.lbl('company.info.data.options')}
              </h2>
            </HBox>

            <div className={styles.gridContainer}>
              {env.clientId == AppClientId.INDEWAL
                ? VEHICLE_OPTIONS_IDW.map(this.renderOption.bind(this))
                : env.clientId == AppClientId.HOOIKAMMER
                ? VEHICLE_OPTIONS_HOOIKAMMER.map(this.renderOption.bind(this))
                : VEHICLE_OPTIONS.map(this.renderOption.bind(this))}
            </div>

            {env.clientId != AppClientId.INDEWAL && env.clientId != AppClientId.HOOIKAMMER && (
              <>
                <h2 className="card-title mb-1 mt-1 text-muted">{this.lbl('company.info.data.options2')}</h2>

                <div className={styles.gridContainer}>{VEHICLE_OPTIONS2.map(this.renderOption.bind(this))}</div>
              </>
            )}
          </Card>
        )}
      </Container>
    );
  }
}

EditVehicleOptionsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_INVOICE_FILTER, REQUEST_DELETE_DOCUMENT]),
    allOptions: selectAllOptions(),
    actions: selectActions(),
    workUpdate: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    toggleOption(optionId, state, callback) {
      let fn = state ? addVehicleOption : removeVehicleOption;
      dispatch(fn(ownProps.vehicle.id, optionId, callback));
    },
    imageUpload(documentDto, work, callback) {
      dispatch(addDocument(ownProps.vehicle?.id, 'vehicle', documentDto, callback, work));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.vehicle?.id, name, value));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(ownProps.vehicle?.id, name));
    },
    deleteDocument(id, callback) {
      dispatch(deleteDocument(ownProps.vehicle?.id, 'vehicle', id, callback));
    },
    downloadZip(files, callback) {
      dispatch(downloadZipFiles(ownProps.vehicle?.id, files, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const EditVehicleOptions = compose(withConnect, withRouter)(EditVehicleOptionsComp);
